import { INote, ISpaces } from "../../../../../common/types";
import getNoteLength from "./getNoteLength";
import { unitDist, unitDistIntervals } from "../parameters";

const getNoteWidth = (note: INote, spaces: ISpaces, barPosition: number, intervalsTask: boolean, chords3Task: boolean, noteDistance: number = 1) => {
    let width = (intervalsTask || chords3Task ? unitDistIntervals : unitDist) * (4 / note.l) * noteDistance;
    if (note.d) width *= 1.5;
    if (note.t) width *= 2 / 3;
    width += Object.keys(spaces)
        .map(pos => {
            if (Number(pos) < barPosition) return 0;
            if (Number(pos) >= barPosition + getNoteLength(note)) return 0;
            return spaces[pos];
        })
        .reduce((a, b) => a + b, 0);
    return width;
};

export default getNoteWidth;
